import { FC, Fragment } from "preact/compat";
import { Tab } from "@headlessui/react";
import { useApp } from "~/core";
import { TabList } from "~/components";
import Toolbar from "./Toolbar";
import { ContentEditorProps } from "./interfaces";
import { Details, Summary } from "./tabs";
import { FALLBACK_IDX, SUMMARY_IDX, TABS } from "./utils";

const ContentEditor: FC<ContentEditorProps> = ({
    tag,
    fallbackTag,
    locale,
    activeTab,
}) => {
    const { help } = useApp();

    return (
        <div className="overflow-y-overlay flex h-[90vh] max-h-[90vh] flex-col">
            <div className="border-b border-gray-300 bg-gray-100 p-4">
                <div className="flex justify-between">
                    <p>
                        <span>Tag: </span>
                        <span className="font-bold">{tag.tag}</span>
                    </p>
                    <span className="rounded-full border border-gray-300 bg-sky-50 px-3 py-0.5 text-sm font-bold">
                        {locale.value}
                    </span>
                </div>
                <p>
                    <span>Description: </span>
                    <span>{tag.name}</span>
                </p>
            </div>
            <Tab.Group
                selectedIndex={activeTab.value}
                onChange={(value) => {
                    activeTab.value = value;

                    if (
                        value === SUMMARY_IDX &&
                        help.admin.isEditorHistory.peek()
                    ) {
                        help.admin.isEditorHistory.value = false;
                    }
                }}
            >
                <div className="flex w-full items-center justify-between px-4 py-2">
                    <Toolbar
                        active={activeTab.value !== SUMMARY_IDX}
                        tag={
                            activeTab.value === FALLBACK_IDX ? fallbackTag : tag
                        }
                    />
                    <TabList items={TABS} active={activeTab.value} />
                </div>
                <Tab.Panels as={Fragment}>
                    <Tab.Panel className="flex flex-1 flex-col">
                        <Details tag={tag} locale={locale.value} />
                    </Tab.Panel>
                    <Tab.Panel className="flex flex-1 flex-col">
                        <Details tag={fallbackTag} locale={locale.value} />
                    </Tab.Panel>
                    <Tab.Panel className="flex flex-1 flex-col">
                        <Summary tag={tag} locale={locale.value} />
                    </Tab.Panel>
                </Tab.Panels>
            </Tab.Group>
        </div>
    );
};

export default ContentEditor;
